import Image from 'next/image'
import Link from 'next/link'
import React from 'react'
import { apiBaseAddress } from '../../config'
import { imageLoaderForStaticImages } from '../../context/utils'
import ColoredDivider from '../coloredDivider.component'
import contrastIcon from "../../public/header/High_contrast_icon.svg";
import { useRouter } from 'next/router'
import { useAppContext } from '../../context/siteMapContext'
import { InfoIcon } from '../footer/info.component'
import useFetchMainData from '../../hooks/useFetchMainData'

const Toolbar = () => {
  const router = useRouter();
  const mainData = useFetchMainData()
  const { highContrastOn, setHighContrastOn } = useAppContext()

  const toggleHighContrastModel = () => {
    setHighContrastOn(!highContrastOn);
  }

  return (
    <>
      <div className='w-full flex flex-wrap flex-col sm:flex-row items-end gap-6 gap-x-6 2xl:gap-y-5 3xl:gap-10 sm:items-center pr-12'>
        <Link href={apiBaseAddress} shallow>
          <a className='hidden 2xl:inline-block order-1'>BELÉPÉS</a>
        </Link>
        <Link href='/imprint' as={'impresszum'} shallow>
          <a className='order-2'>KAPCSOLAT</a>
        </Link>
        <Link href='https://hirlevel.bp18.hu'>
          <a className='order-3'>HÍRLEVÉL</a>
        </Link>
        <div className='order-4 2xl:order-4 cursor-pointer flex gap-x-[16px] gap-y-[6px] sm:gap-y-[16px] flex-wrap w-[86px] sm:w-[200px]' tabIndex={0}>
          <span onClick={toggleHighContrastModel}>
            <Image
              src={contrastIcon}
              title='Megjelenítés gyengénlátóknak'
              alt='Megjelenítés gyengénlátóknak'
              loader={imageLoaderForStaticImages}
              height={18}
              width={18}
            />
          </span>
          {mainData.facebook && <InfoIcon iconName={'Facebook'} url={mainData.facebook} />}
          {mainData.youtube && <InfoIcon iconName={'YouTube'} url={mainData.youtube} />}
          {mainData.instagram && <InfoIcon iconName={'Instagram'} url={mainData.instagram} />}
          {mainData.tikTok && <InfoIcon iconName={'TikTok'} url={mainData.tikTok} />}
          {mainData.threads && <InfoIcon iconName={'Threads'} url={mainData.threads} />}
        </div>
      </div>
      <div className='z-2 relative h-[3px] w-full my-4 2xl:my-8 bg-white'>
        {!highContrastOn && <ColoredDivider />}
      </div>
    </>
  )
}

export default Toolbar
